import {
  CalendarDays,
  CircleDot,
  SlidersHorizontal,
  SquareCheckBig,
  TextAlignStart,
} from "lucide-react";
import type { QuestionType } from "@shared-domain/survey/contract";

// 設問タイプの表示名+アイコンの正本 (⑦)。builder と定義閲覧 (SurveyDef) で共用し名称乖離を防ぐ。
// アイコンは lucide canonical 名を使用 (AlignLeft/CheckSquare 等の deprecated alias は不使用)。
// キー順 = builder の設問追加パレットのボタン順 (日付は末尾)。
export const QTYPE: Record<
  QuestionType,
  { label: string; Icon: typeof CircleDot }
> = {
  radio: { label: "ラジオボタン（単一選択）", Icon: CircleDot },
  checkbox: { label: "チェックボックス（複数選択）", Icon: SquareCheckBig },
  text: { label: "自由記述", Icon: TextAlignStart },
  scale: { label: "数値評価", Icon: SlidersHorizontal },
  date: { label: "日付", Icon: CalendarDays },
};
